module.exports = __webpack_public_path__ + "static/lights15-95da402ce80db33da30b2e77260c92c3.jpg";